// extracted by mini-css-extract-plugin
module.exports = {"signUp":"Signup_signUp__27u3l","loginBox":"Signup_loginBox__1-9Jw","signUpButton":"Signup_signUpButton__2p_GV"};